import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { ContentProvider } from "@/providers/ContentProvider";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/HomePage";

import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyDetailPage from "@/pages/CaseStudiesPage/CaseStudyDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import IntakePage from "@/pages/IntakePage";
import EmailVerificationPage from "@/pages/EmailVerificationPage";
import NDAGatePage from "@/pages/NDAGatePage";
import NDACompletePage from "@/pages/NDACompletePage";
import SchedulePage from "@/pages/SchedulePage";
import EngagementChoicePage from "@/pages/EngagementChoicePage";
import AsyncQuestionnairePage from "@/pages/AsyncQuestionnairePage";
import QuestionnaireSubmittedPage from "@/pages/QuestionnaireSubmittedPage";
import AboutPage from "@/pages/AboutPage";
import SigninCallbackPage from "@/pages/SigninCallbackPage";
import SignoutCallbackPage from "@/pages/SignoutCallbackPage";
import LoginPage from "@/pages/LoginPage";
import ActivateAccountPage from "@/pages/ActivateAccountPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PaymentPolicyPage from "@/pages/PaymentPolicyPage";
import { FeedbackProvider } from "./providers/FeedbackProvider";
import { ClientFeedbackProvider } from "./providers/ClientFeedbackProvider";

export default function App() {
  return (
    <ContentProvider>
      <FeedbackProvider>
        <ClientFeedbackProvider>
          <Routes>
            <Route path="/auth/activate" element={<ActivateAccountPage />} />
            <Route
              path="/auth/signin-callback"
              element={<SigninCallbackPage />}
            />
            <Route
              path="/auth/signout-callback"
              element={<SignoutCallbackPage />}
            />

            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route
                path="/solutions"
                element={<Navigate to="/#pricing" replace />}
              />
              <Route
                path="/services/ai-development"
                element={<Navigate to="/services" replace />}
              />
              <Route
                path="/services/cloud-infrastructure"
                element={<Navigate to="/services" replace />}
              />
              <Route path="/case-studies" element={<CaseStudiesPage />} />
              <Route
                path="/case-studies/:slug"
                element={<CaseStudyDetailPage />}
              />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/intake" element={<IntakePage />} />
              <Route path="/verify/email" element={<EmailVerificationPage />} />
              <Route path="/verify/nda" element={<NDAGatePage />} />
              <Route path="/nda/complete" element={<NDACompletePage />} />
              <Route path="/engage" element={<EngagementChoicePage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route
                path="/questionnaire"
                element={<AsyncQuestionnairePage />}
              />
              <Route
                path="/questionnaire/submitted"
                element={<QuestionnaireSubmittedPage />}
              />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/legal/privacy" element={<PrivacyPage />} />
              <Route path="/legal/terms" element={<TermsPage />} />
              <Route path="/legal/payments" element={<PaymentPolicyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
          <Toaster />
        </ClientFeedbackProvider>
      </FeedbackProvider>
    </ContentProvider>
  );
}
